export const keyToRobotjsMapping = {
    escape: 'escape',
    minus: '-',
    equal: '=',
    backspace: 'backspace',
    tab: 'tab',
    bracketleft: '[',
    bracketright: ']',
    enter: 'enter',
    semicolon: ';',
    quote: "'",
    backquote: '`',
    comma: ',',
    period: '.',
    slash: '/',
    space: 'space',
    capslock: 'space',
    intlbackslash: '\\',
    backslash: '\\',
    delete: 'delete',
    end: 'end',
    pageup: 'pageup',
    pagedown: 'pagedown',
    home: 'home',
    f1: 'f1',
    f2: 'f2',
    f3: 'f3',
    f4: 'f4',
    f5: 'f5',
    f6: 'f6',
    f7: 'f7',
    f8: 'f8',
    f9: 'f9',
    f10: 'f10',
    f11: 'f11',
    f12: 'f12',
}

export const mouseButtonToRobotJsMapping = ['left', 'middle', 'right']
